import React, { useState } from 'react';
import Form from '../../Modules/form/components/Form';
import { Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import Box from '@material-ui/core/Box';
import ProvisionMonthSelect from '../../Modules/form/components/specialized/ProvisionMonthSelect';
import { exportDataRequest } from './hooks';
import LoadingButton from '../Helpers/LoadingButton';
import AgencyMultiselect from 'Modules/form/components/specialized/AgencyMultiSelect';

const FORM_KEY = 'commission_franchisepartner_datev';
const EXPORT_TYPE = 'commission_franchisepartner_datev';

const CommissionFranchisePartnerExport_Datev = () => {
    const [loading, setLoading] = useState(false);
    const [errorDownload, setErrorDownload] = useState(null);

    const handleExportSubmit = async (values) => {
        setErrorDownload(null);
        console.log('Export values:', values);

        const monthDate = new Date(values.provision_month);
        if (isNaN(monthDate)) {
            setErrorDownload(new Error('Ungültiger Monat!'));
            return;
        }

        try {
            setLoading(true);
            await exportDataRequest(EXPORT_TYPE, values);
        } catch (err) {
            errorDownload(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box mt={3}>
            <Card data-cy="card-CommissionFranchisePartnerExport_Datev">
                <h6 className="card-header">Provisionsabrechnung - Belege Franchisepartner (DATEV)</h6>
                <CardBody>
                    <p>
                        Unter folgendem Link kann die Datei für die Provisionsabrechnung heruntergeladen
                        werden.
                    </p>
                    <Form
                        onSubmit={handleExportSubmit}
                    >
                        <Row>
                            <Col>
                                <ProvisionMonthSelect
                                    name="provision_month"
                                    fullWidth
                                    label="Monat"
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label>Agentur(en):</Label>
                                    <AgencyMultiselect
                                        name="agency"
                                        label="Agentur"
                                        fullWidth
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="text-center">
                            <LoadingButton
                                color="primary"
                                id={FORM_KEY}
                                title="Klicken um die Datei herunterzuladen"
                                type="submit"
                                isLoading={loading}
                            >
                                Herunterladen
                            </LoadingButton>
                        </div>
                        {errorDownload && <div className="text-danger">{errorDownload.message}</div>}
                    </Form>
                </CardBody>
            </Card>
        </Box>
    );
};

CommissionFranchisePartnerExport_Datev.propTypes = {

};

CommissionFranchisePartnerExport_Datev.defaultProps = {

};

export default CommissionFranchisePartnerExport_Datev;
